import axios from 'axios';
import api from '@/api/index';
import _ from 'lodash';
import Vue from 'vue';
import router from "@/router/index"
import {
    apiDomain
} from '@/config/env';

const _this = new Vue();
const generateApiMap = (map) => {
    const facade = {};
    _.forEach(map, function(value, key) {
        facade[key] = toMethod(value);
    });
    return facade;
};

const toMethod = (options) => {
    options.method = options.method || 'post';
    return (params = {}, attachedParams) => {
        let config = {
            closeLoading: false,
        };
        config = _.merge(config, options.config, attachedParams);
        // 导入文件 需要转换
        // if (config.isImport) {
        //     options.url = options.fileUrl + formatQueryData(params.query);
        //     const fd = new FormData();
        //     fd.append('file', params.file);
        //     params = fd;
        // }
        let currentDomain = window.location.hostname;
        var cur = window.document.location.href;
        var pathname = window.document.location.pathname;
        var pos = cur.indexOf(pathname);
        var localhostPath = cur.substring(0, pos);
        if (currentDomain === 'localhost' || currentDomain.indexOf('192.168.200') > -1 || currentDomain === '192.168.1.105') {
            // localhostPath = 'http://192.168.23.251:8061'
            localhostPath = 'https://sycsp.yuanquanyun.com.cn'
        }
        sessionStorage.setItem('location', localhostPath)
        console.log(currentDomain, '...currentDomaincurrentDomaincurrentDomain')
        return sendApiInstance(options.method, localhostPath + options.url, params, config);
        // return sendApiInstance(options.method, apiDomain + options.url, params, config);
    };
};

// 创建axios实例
const createApiInstance = (config = {}, method) => {
    const _config = {
        withCredentials: false, // 跨域
        baseURL: '',
        timeout: 10000,
        closeLoading: false,
        headers: {},
    };

    // token
    _config.headers['Authentication'] = _this.getCookie('utoken');
    //特殊处理 编辑演员登录，token设置 与wetrue登录不同token不同，两套逻辑。
    if (window.sessionStorage.getItem('actorEditToken')) {
        _config.headers['actorEditToken'] = window.sessionStorage.getItem('actorEditToken');
    }
    config = _.merge(_config, config);
    if (config.isImport) {
        config.headers['Content-Type'] = 'multipart/form-data';
    } else if (config.isExport) {
        // config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
        // config.headers['responseType'] = 'blob';
    }
    return axios.create(config);
};

async function getWxAuth() {
    // const result = await api.getWxAuth({
    //     url: delParam(['access_token', 'access_code'], window.location.href),
    // });
    // if (result.datas) {
    //     window.location.href = result.datas.url;
    // }
}

const err_check = (status, message, data) => {
    if (status === 0) {
        return true;
    }
    return false;
};

let count = 0;
const sendApiInstance = (method, url, params, config = {}) => {
    if (!url) {
        return;
    }
    const instance = createApiInstance(config);

    instance.interceptors.response.use(
        async(response) => {
            const {
                code,
                msg,
                data,
            } = response.data;
            if (err_check(code, msg, data)) {
                return response.data;
            } else {
                // 401 1,正常接口401 走续token方法；2,继token方法401 走重新登录接口
                // return response.data;
                // console.log(url, refreshToken, count, 'url');
                // return;
                if (code === 401) {
                    _this.setCookie('utoken', '', 7);
                    sessionStorage.clear()
                    if (router.history.current.path != '/') {
                        router.replace({
                            path: "/"
                        })
                    }
                    return response.data
                } else {
                    return response.data;
                }
            }
        }, () => {
            alert('网络异常，请稍后再试!');
            return null;
        }
    );
    if (method === 'get') {
        params = {
            params: params,
        };
    }
    if (method === 'delete') {
        params = {
            data: params,
        };
    }
    return instance[method](url, params, config);
};

export default {
    generateApiMap
};


// WEBPACK FOOTER //
// ./src/api/apiUtil.js